<template>
    <section  v-if="hasPermissions(['Budgeting-Staffing-Fixed Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="title_page"/>

        <RoomTaskAdvancedSearchVue
            class="mt-5"
            ref="advanced_search"
            :module_name="'wizard'"
            :checkeable="true"
            :autoincrement="true"
            :rest_api="rest_api"
            :rest_api_pagination="pagination_rest_api"
            :filter_options="filter_options"
            :table_headers="table_headers"
            @passInitialData="getInitialData($event)"
            @passData="getData($event)"
        >
        <template v-slot:overtable>

            <div class="modal__buttons text-center text-md-left">
                <label v-html="`Total Hours: ${options ? options.all_annual_minutes: 0}`"/>
                <!-- Estimated FTEs = Total Hours / 2080 -->
                <label class="ml-5" v-html="`Estimated FTEs: ${options ? options.estimated_ftes: 0}`"/>
            </div>
        </template>
        </RoomTaskAdvancedSearchVue>

        <div class="modal__buttons text-center text-md-right mb-3">
            <button type="button" class="modal__buttons__item w-auto button--2" v-html="`Add Selected Duties <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" style="width:300px;" @click="sendFixedData()"/>
            <!-- <button class="modal__buttons__item button--2" v-html="`Go! <img class='ml-2'`"/> -->
            <button type="button" class="modal__buttons__item button--2" v-html="`Refresh <img class='ml-2'`" @click="reloaded()" style="margin-left:10px;"/>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />
        <WaitingModal/>
    </section>
    <section v-else class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            you do not have permission for this section. contact your system administrator
        </h1>
    </section>
</template>

<script>
import axios                     from    'axios'
import Breadcrumb                from    '@/components/BreadcrumbComponent/Breadcrumb'
import FormResources             from    './form_resource'
import WaitingModal              from    '@/components/WaitingModal'
import Methods                   from    './Methods'
import Resources                 from    './resources'
import DeletionModal             from    '@/components/DeletionModal'
import RoomTaskAdvancedSearchVue from    '@/components/BuildingComponent/Rooms/RoomTaskAdvancedSearch/RoomTaskAdvancedSearch.vue'

/**********styles **********************************************/
import 'vuetify/dist/vuetify.min.css'
import { Notyf }    from    'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
})
/***************************************************************/

export default {

    name: 'Wizzard',

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        RoomTaskAdvancedSearchVue
    },

    mixins:[
        Methods,
    ],

    data() {
        return {
            notyf,
            axios,
            user:               this.get_user(),
            scenario_id:        this.$route.params.id,
            parent:             {},
            parent_id:          '',
            title_page:         'Wizard',
            rest_api:           `wizzards/${this.$route.params.id}`,
            lite_rest_api:      `wizzards`,
            pagination_rest_api:`wizzards_pagination`,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            select_all:         false,

            /**** Options ************************************/
            boolean_options:    Resources.boolean_options,
            excl_options:       Resources.excl_options,
            freq_options:       Resources.freq_options,
            filter_options:     Resources.filter_options,
            /*************************************************/

            form_data:          FormResources.form_data,
            add_btn:            'Add Wizzard',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       undefined,
            single_object:      {},
            rooms:              [],
            task_frequencies:   [],
            array_options:      {},
            date:               '',
            options:            null
        }
    },

    async mounted()
    {
        if(this.hasPermissions(['Budgeting-Staffing-Fixed Write']))
        {
            // await this.api_request()
        }
        else
        {
            window.location.href = '/'
        }
    },
}
</script>